import { render, staticRenderFns } from "./UiModalInfo.vue?vue&type=template&id=53b9be0b&"
import script from "./UiModalInfo.vue?vue&type=script&lang=js&"
export * from "./UiModalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports